module.exports = __webpack_public_path__ + "img/plant_form.84e781a9.png";